// extracted by mini-css-extract-plugin
export var container = "_jl-0";
export var dotAnimation = "_jl-2";
export var dotsLoading = "_jl-1";